/* eslint-disable react/prop-types */
import React, { Component } from "react";
import {
  Table, Form, Button, Header, Icon, Divider,
  Modal, Popup, Grid
} from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { read, write } from "xlsx";
import { logAction } from "../actions/changeActiveItemActions";
import Constants from "./utilities/Constants";
import Strings from "./utilities/StringSelector";
import Utils from "./utilities/Utils";
import ColumnsDropdown, { defaultColumns } from "./ColumnsDropdown";

// Regex to match agains the form input to know if the user typed an IP or a device name
const ipRegex = new RegExp("^[0-2][0-9.]*$");
const nameRegex = new RegExp("^[A-Za-z][A-Za-z-]*");
const macRegex = new RegExp("^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$");

const statusKeyArray = [
  Strings.OK_STRING,
  Strings.ALARM,
  Strings.OFFLINE_STRING,
  Strings.ONLINE_STRING,
  Strings.FAULT_STRING,
  Strings.CONFIG_ERROR_STRING,
  Strings.DUPLICATE_IP_STRING
];

const statusValueArray = [
  Constants.OK,
  Constants.DIAGNOSTIC,
  Constants.OFFLINE,
  Constants.ONLINE,
  Constants.FAULT,
  Constants.CONFIG_ERROR,
  Constants.DUPLICATE_IP
];

const blackListTypesArray = [
  Strings.MONITORING_BLACKLIST_STRING,
  Strings.BLACKLIST_OK_STRING,
  Strings.BLACKLIST_ALARM_STRING,
  Strings.BLACKLIST_OFFLINE_STRING,
  Strings.BLACKLIST_ONLINE_STRING,
  Strings.BLACKLIST_FAULT_STRING,
  Strings.BLACKLIST_DUPLICATE_IP_STRING,
  Strings.BLACKLIST_CONFIG_ERROR_STRING
];

const UtilsInstance = new Utils();
var cameFromHomepageListClick = false;

class LiveList extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      formInput: "",
      column: null,
      sortDirection: "ascending",
      originalDevices: [],
      devices: [],
      isColumnClicked: false,
      isStatusCellClicked: false,
      showModal: false,
      showZeroIpModal: false,
      clickedDevice: "",
      clickedMac: "",
      maintenance: [],
      networkAvailability: "",
      ping: [],
      activeColumns: JSON.parse(localStorage.getItem(Constants.LL_ACTIVE_COLUMNS) || "null") || defaultColumns
    };
    cameFromHomepageListClick = false;
  }

  // The network availabilty is calculated this way:
  // Percentage of time the network was on OK status + percentage of the time the network was on DIAGNOSTIC status
  getNetworkAvailability = (availabilityData) => {
    return (availabilityData.percentageAvailable + availabilityData.percentageDiagnostic).toFixed(0).concat("%");
  }

  addAditionalInfoToDevices = () => {
    let devicesCopy = JSON.parse(JSON.stringify(this.state.originalDevices));

    for (let i = 0; i < devicesCopy.length; i++) {
      let pingData = this.getPingData(devicesCopy[i]);

      devicesCopy[i].availability = this.getDeviceAvailability(devicesCopy[i]);
      devicesCopy[i].pingAvg = pingData.pingAvg;
      devicesCopy[i].pingCurrent = pingData.pingCurrent;
      devicesCopy[i].lostPings = pingData.lostPings;
      devicesCopy[i].lostPingsPercentage = pingData.lostPingsPercentage;
      devicesCopy[i].blacklistText = "";

      if (devicesCopy[i].isInBlacklist) {
        devicesCopy[i].severity = 0;

        if (devicesCopy[i].isBlacklistAlarm
          || devicesCopy[i].isBlacklistAvailability
          || devicesCopy[i].isBlacklistFault
          || devicesCopy[i].isIgnoringDeltaErrors
          || devicesCopy[i].isIgnoringLog) {

          if (devicesCopy[i].status === Constants.FAULT) {
            devicesCopy[i].blacklistText = Strings.BLACKLIST_FAULT_STRING;
          }
          else if (devicesCopy[i].status === Constants.DUPLICATE_IP) {
            devicesCopy[i].blacklistText = Strings.BLACKLIST_DUPLICATE_IP_STRING;
          }
          else if (devicesCopy[i].status === Constants.DIAGNOSTIC) {
            devicesCopy[i].blacklistText = Strings.BLACKLIST_ALARM_STRING;
          }
          else if (devicesCopy[i].status === Constants.OK) {
            devicesCopy[i].blacklistText = Strings.BLACKLIST_OK_STRING;
          }
          else if (devicesCopy[i].status === Constants.ONLINE) {
            devicesCopy[i].blacklistText = Strings.BLACKLIST_ONLINE_STRING;
          }
          else if (devicesCopy[i].status === Constants.OFFLINE) {
            devicesCopy[i].blacklistText = Strings.BLACKLIST_OFFLINE_STRING;
          }
          else if (devicesCopy[i].status === Constants.CONFIG_ERROR) {
            devicesCopy[i].blacklistText = Strings.BLACKLIST_CONFIG_ERROR_STRING;
          }
        }
        else if (devicesCopy[i].isIgnoringMonitoring) {
          devicesCopy[i].blacklistText = Strings.MONITORING_BLACKLIST_STRING;
        }
      }
      else {
        if (devicesCopy[i].status === Constants.FAULT) {
          devicesCopy[i].severity = 6;
        } else if (devicesCopy[i].status === Constants.DUPLICATE_IP) {
          devicesCopy[i].severity = 5;
        } else if (devicesCopy[i].status === Constants.DIAGNOSTIC) {
          devicesCopy[i].severity = 4;
        } else if (devicesCopy[i].status === Constants.OK) {
          devicesCopy[i].severity = 3;
        } else if (devicesCopy[i].status === Constants.ONLINE) {
          devicesCopy[i].severity = 2;
        } else if (devicesCopy[i].status === Constants.OFFLINE) {
          devicesCopy[i].severity = 1;
        } else if (devicesCopy[i].status === Constants.CONFIG_ERROR) {
          devicesCopy[i].severity = 7;
        }
      }
    }

    this.setState({
      devices: devicesCopy,
      originalDevices: devicesCopy
    });
  }

  // Creates a list with an entry that matches the address received from 
  // a click on the supervisor's last event button
  handleSupervisorIPSearch = () => {
    if (this.props.match.params.ip !== undefined
      && this.props.match.params.ip !== null
      && this.props.match.params.ip !== -1) {
      let ipToSearch = this.props.match.params.ip;

      // Here we reuse the Homepage last click variable because the context is similar
      // and the behavior of the filtering is the same
      cameFromHomepageListClick = true;
      const len = this.state.originalDevices.length;
      const searchedDevices = [];

      for (let i = 0; i < len; i++) {
        if (this.state.originalDevices[i].ip.toString() === ipToSearch.toString()) {
          searchedDevices.push(this.state.originalDevices[i]);
        }
      }

      // Erase the address, so the page behaves normaly after filtering once
      this.props.match.params.ip = -1;

      // Show all devices that matched the address or none
      if (searchedDevices.length > 0) {
        this.setState({ devices: searchedDevices });
      } else {
        this.setState({ devices: [] });
      }
    }
  }

  // Sorts the table when the user clicks on one of the columns
  handleSort = clickedColumn => () => {

    this.setState({
      isColumnClicked: true
    });

    // The user wants to order the live list by name ascending
    if (clickedColumn === "name" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "name",
            false,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by name descending
    else if (clickedColumn === "name" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "name",
            true,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "ascending",
      });
    }
    // Sort by device tag using the same behavior as the PRO edition.
    else if (clickedColumn === "tag" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(UtilsInstance.sortBy("tag", false, function (a) { return UtilsInstance.treatUppercase(a || ""); })),
        sortDirection: "descending",
      });
    }
    else if (clickedColumn === "tag" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(UtilsInstance.sortBy("tag", true, function (a) { return UtilsInstance.treatUppercase(a || ""); })),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by ip ascending
    else if (clickedColumn === "ip" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort((a, b) => {
          const num1 = Number(a.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
          const num2 = Number(b.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
          return num1 - num2;
        }),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by ip descending
    else if (clickedColumn === "ip" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.reverse(),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by status ascending
    else if (clickedColumn === "status" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "severity",
            false,
            parseInt)),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by status descending
    else if (clickedColumn === "status" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "severity",
            true,
            parseInt)),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by the number of alarms ascending
    else if (clickedColumn === "nAlarm" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "nAlarm",
            false,
            parseInt)),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by the number of alarms descending
    else if (clickedColumn === "nAlarm" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "nAlarm",
            true,
            parseInt)),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by the number of faults ascending
    else if (clickedColumn === "nFault" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "nFault",
            false,
            parseInt)),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by the number of faults descending
    else if (clickedColumn === "nFault" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "nFault",
            true,
            parseInt)),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by availability ascending
    else if (clickedColumn === "availability" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "availability",
            false,
            parseInt)),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by availability descending
    else if (clickedColumn === "availability" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "availability",
            true,
            parseInt)),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the ping list by lostPingsPercentage ascending
    else if (clickedColumn === "lostPingsPercentage" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "lostPingsPercentage",
            false,
            parseFloat)),
        sortDirection: "descending",
      });
    }
    // The user wants to order the ping list by lostPingsPercentage descending
    else if (clickedColumn === "lostPingsPercentage" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "lostPingsPercentage",
            true,
            parseFloat)),
        sortDirection: "ascending",
      });
    }
  }

  // Creates a list with entries that match the IP passed on the form
  handleIPSearch = () => {
    const len = this.state.originalDevices.length;
    const searchedDevices = [];
    for (let i = 0; i < len; i++) {
      if (this.state.originalDevices[i].ip === this.state.formInput) {
        searchedDevices.push(this.state.originalDevices[i]);
      }
    }

    if (searchedDevices.length > 0) {
      this.setState({ devices: searchedDevices });
    } else {
      this.setState({ devices: [] });
    }
  }

  // Creates a list with an entry that matches the IP received from 
  // a click on the homepage network status list
  handleNetworkStatusIPSearch = () => {
    if (this.props.location.state !== undefined) {
      if (this.props.location.state.deviceIP !== undefined) {
        cameFromHomepageListClick = true;
        const len = this.state.originalDevices.length;
        const searchedDevices = [];

        for (let i = 0; i < len; i++) {
          if (this.state.originalDevices[i].ip === this.props.location.state.deviceIP) {
            searchedDevices.push(this.state.originalDevices[i]);
          }
        }
        // Show all devices that matched the IP or none
        if (searchedDevices.length > 0) {
          this.setState({ devices: searchedDevices });
        } else {
          this.setState({ devices: [] });
        }
      }
    }
  }

  // Creates a list with entries that match the name passed on the form
  handleNameSearch = () => {
    const len = this.state.originalDevices.length;
    const searchedDevices = [];

    for (let i = 0; i < len; i++) {
      // Uppercases both strings before comparison to allow search flexibility
      // Also remove all whitespaces in both strings before comparing
      if (this.state.originalDevices[i].name != null && this.state.formInput != null) {

        let noWhitespaceUppercasedDeviceName = this.state.originalDevices[i].name.toUpperCase().replace(/\s/g, "");
        let noWhitespaceUppercasedFormInput = this.state.formInput.toUpperCase().replace(/\s/g, "");

        const deviceTag = (this.state.originalDevices[i].tag || "").toUpperCase().replace(/\s/g, "");
        if (noWhitespaceUppercasedDeviceName.indexOf(noWhitespaceUppercasedFormInput) !== -1
          || deviceTag.indexOf(noWhitespaceUppercasedFormInput) !== -1) {
          searchedDevices.push(this.state.originalDevices[i]);
        }
      }
    }

    if (searchedDevices.length > 0) {
      this.setState({ devices: searchedDevices });
    } else {
      this.setState({ devices: [] });
    }
  }

  // Creates a list with entries that match the first letter of the name
  handleFirstLetterNameSearch = () => {
    const len = this.state.originalDevices.length;
    const searchedDevices = [];

    for (let i = 0; i < len; i++) {
      // Uppercases both strings before comparison to allow search flexibility
      if (this.state.originalDevices[i].name != null && this.state.formInput != null) {
        if (this.state.originalDevices[i].name[0].toUpperCase() === this.state.formInput.toUpperCase()) {
          searchedDevices.push(this.state.originalDevices[i]);
        }
      }
    }

    if (searchedDevices.length > 0) {
      this.setState({ devices: searchedDevices });
    } else {
      this.setState({ devices: [] });
    }
  }

  isItPossiblyABlacklistSearchText = () => {
    let uppercaseInput = this.state.formInput.toUpperCase();

    for (let i = 0; i < blackListTypesArray.length; i++) {
      const blackListType = blackListTypesArray[i].toUpperCase();
      if (blackListType.includes(uppercaseInput)) {
        return true;
      }
    }

    return false;
  }

  handleBlacklistSearch = () => {
    const uppercaseInput = this.state.formInput.toUpperCase();
    const searchedDevices = [];

    for (let i = 0; i < this.state.originalDevices.length; i++) {
      if (this.state.originalDevices[i].isInBlacklist) {
        const upperBlacklistText = this.state.originalDevices[i].blacklistText.toUpperCase();

        if (upperBlacklistText.includes(uppercaseInput)) {
          searchedDevices.push(this.state.originalDevices[i]);
        }
      }
      else if (this.state.originalDevices[i].name.toUpperCase().includes(uppercaseInput)) {
        searchedDevices.push(this.state.originalDevices[i]);
      }
    }

    if (searchedDevices.length > 0) {
      this.setState({ devices: searchedDevices });
    } else {
      this.setState({ devices: [] });
    }
  }

  // Creates a list with entries that match the status passed on the form
  handleStatusSearch = (status) => {
    const uppercaseInput = this.state.formInput.toUpperCase();
    const len = this.state.originalDevices.length;
    const searchedDevices = [];

    for (let i = 0; i < len; i++) {
      if (this.state.originalDevices[i].status === status) {
        searchedDevices.push(this.state.originalDevices[i]);
      }
      else if (this.state.originalDevices[i].name.toUpperCase().includes(uppercaseInput)) {
        searchedDevices.push(this.state.originalDevices[i]);
      }
    }

    if (searchedDevices.length > 0) {
      this.setState({ devices: searchedDevices });
    } else {
      this.setState({ devices: [] });
    }
  }

  handleMacAddressSearch = () => {
    const len = this.state.originalDevices.length;
    const searchedDevices = [];

    for (let i = 0; i < len; i++) {
      // Uppercases both strings before comparison to allow search flexibility
      if (this.state.originalDevices[i].mac != null && this.state.formInput != null) {
        if (this.state.originalDevices[i].mac.toUpperCase().indexOf(this.state.formInput.toUpperCase()) !== -1) {
          searchedDevices.push(this.state.originalDevices[i]);
        }
      }
    }

    if (searchedDevices.length > 0) {
      this.setState({ devices: searchedDevices });
    } else {
      this.setState({ devices: [] });
    }
  }

  /*
    If the user clicks on the table cell of a device a verification starts:
    If that device status is OK, Alarm, Duplicated or Online he is sent to the log page filtering all events by the ip of the device
    If that device status is Offline or Fault he is asked to delete the device or be sent to the log list
    If that device status is different from any of the above (not expected) he is sent to the log list too
  */
  handleLineClick = (ip, status, mac) => () => {
    if (status === Constants.OK || status === Constants.DIAGNOSTIC || status === Constants.ONLINE) {
      this.props.onChangeLog();
      this.props.history.push({
        pathname: "/log",
        state: { deviceIP: ip }
      });
    }
    else if (status === Constants.OFFLINE || status === Constants.FAULT || status === Constants.DUPLICATE_IP) {
      this.setState({ clickedDevice: ip, clickedMac: mac }, () => {
        this.setState({ showModal: true });
      });
    }
    else {
      this.props.onChangeLog();
      this.props.history.push({
        pathname: "/log",
        state: { deviceIP: ip }
      });
    }
  }

  /*
    If the user typed a substring of one of the four possible status:
    OK, Offline, Online, Diagnósitico (In uppercase, lowercase or a mix of them)
    it returns and index to match against the json received from the server or -1
  */
  matchFormInputStatus = () => {
    const len = statusKeyArray.length;
    let matchedIndex = -1;
    for (let i = 0; i < len; i++) {
      // Uppercases the user input before comparison to allow for a more flexible search
      // It doesn't matter if the user typed in uppercase, lowercase or any combination of them
      const status = statusKeyArray[i].toUpperCase();
      const normalizedUserInput = this.state.formInput.toUpperCase();
      if (status.indexOf(normalizedUserInput) !== -1) {
        matchedIndex = i;
        break;
      }
    }
    return matchedIndex;
  }

  /*
    Filters the page list showing only the devices that match the
    ip, name or status the user has typed in the form
  */
  handleSubmit = () => {
    cameFromHomepageListClick = false;
    const matchValue = this.matchFormInputStatus();
    const isBlacklistSearch = this.isItPossiblyABlacklistSearchText();

    if (this.state.formInput !== "" && this.state.formInput.length === 1) {
      this.handleFirstLetterNameSearch();
    }
    else if (this.state.formInput !== "" && matchValue !== -1) {
      this.handleStatusSearch(statusValueArray[matchValue]);
    }
    else if (this.state.formInput !== "" && isBlacklistSearch) {
      this.handleBlacklistSearch();
    }
    else if (this.state.formInput !== "" && ipRegex.test(this.state.formInput)) {
      this.handleIPSearch();
    }
    else if (this.state.formInput !== "" && macRegex.test(this.state.formInput)) {
      this.handleMacAddressSearch();
    }
    else if (this.state.formInput !== "" && nameRegex.test(this.state.formInput)) {
      this.handleNameSearch();
    }
    else if (this.state.formInput === "") {
      this.setState({ devices: this.state.originalDevices });
    }
  }

  retrieveData = async () => {
    // Retrieve devices list only if the input form is empty and the user didn't come from
    // a NetworkStatus click and the user didn't sort the table by clicking a column header
    if (this.state.formInput === "" && !cameFromHomepageListClick && !this.state.isColumnClicked) {

      let promissesArray = [];

      // Get the maintenance data to calculate the avaiability
      promissesArray.push(
        fetch(Constants.REQUEST_IP_ADDRESS + "maintenance", { mode: "cors" })
          .then(res => res.json())
          .then(data => data)
      );

      // then get the live list data itself
      promissesArray.push(
        fetch(Constants.REQUEST_IP_ADDRESS, { mode: "cors" })
          .then(res => res.json())
          .then(data => data)
      );

      // then get the data to calculate the network availability
      promissesArray.push(
        fetch(Constants.REQUEST_IP_ADDRESS + "graphicNetworkStatus", { mode: "cors" })
          .then(res => res.json())
          .then(data => data)
      );

      promissesArray.push(
        fetch(Constants.REQUEST_IP_ADDRESS + "ping", { mode: "cors" })
          .then(res => res.json())
          .then(data => data)
      );

      let resolvedPromisses = await Promise.all(promissesArray);

      let maintenance = resolvedPromisses[0].sort((a, b) => {
        const num1 = Number(a.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
        const num2 = Number(b.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
        return num1 - num2;
      });

      let livelist = resolvedPromisses[1].sort((a, b) => {
        const num1 = Number(a.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
        const num2 = Number(b.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
        return num1 - num2;
      });

      let networkAvailability = this.getNetworkAvailability(resolvedPromisses[2]);

      let ping = resolvedPromisses[3].sort((a, b) => {
        const num1 = Number(a.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
        const num2 = Number(b.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
        return num1 - num2;
      });

      this.setState({
        maintenance: maintenance,
        devices: livelist,
        originalDevices: livelist,
        ping: ping,
        networkAvailability: networkAvailability
      }, () => {
        this.addAditionalInfoToDevices();
        this.handleNetworkStatusIPSearch();
        this.handleSupervisorIPSearch();
      });
    }
  }

  /* 
  Create Status Cell
  parameters: device: JSON information of the device being added to the table
  return: A new table cell stylized according to the current device status
*/
  getStatusBadgeStyle = (device) => {
    if (device.isInBlacklist && device.isIgnoringMonitoring) {
      return statusBadgeStyles.blacklist;
    }
    if (device.status === Constants.OK) return statusBadgeStyles.ok;
    if (device.status === Constants.DIAGNOSTIC) return statusBadgeStyles.diagnostic;
    if (device.status === Constants.OFFLINE) return statusBadgeStyles.offline;
    if (device.status === Constants.ONLINE) return statusBadgeStyles.online;
    if (device.status === Constants.FAULT) return statusBadgeStyles.fault;
    if (device.status === Constants.DUPLICATE_IP) return statusBadgeStyles.duplicated;
    if (device.status === Constants.CONFIG_ERROR) return statusBadgeStyles.configError;
    return statusBadgeStyles.default;
  };

  createStatusCell = (device) => (
    <Table.Cell
      selectable
      verticalAlign="middle"
      style={{ ...statusCellStyle, display: this.state.activeColumns.status ? "table-cell" : "none" }}
      onClick={this.handleLineClick(device.ip, device.status, device.mac)}>
      <span style={this.getStatusBadgeStyle(device)}>
        {this.getStatusTextForCSV(device) || "-"}
      </span>
    </Table.Cell>
  );

  /*
    Returns a normal table cell if the ip is not equal to 0.0.0.0
    If IP == 0.0.0.0 returns a table cell with an orange background
  */
  createIpCell = (device) => {
    if (device.ip === "0.0.0.0") {
      return (
        <Table.Cell
          style={{ ...zeroIpCellStyle, display: this.state.activeColumns.ip ? "table-cell" : "none" }}
          verticalAlign="middle"
          onClick={this.handleZeroIpCellClick(device.ip, device.mac)}>
          <span style={zeroIpBadgeStyle}>{device.ip}</span>
        </Table.Cell>
      );
    } else {
      return <Table.Cell style={{ display: this.state.activeColumns.ip ? "table-cell" : "none" }} verticalAlign="middle">{device.ip}</Table.Cell>;
    }
  }

  handleZeroIpCellClick = (ip, mac) => () => {
    this.setState({
      clickedDevice: ip,
      clickedMac: mac,
      showZeroIpModal: true
    });
  }

  /*
    Adjusts the size of the table so that it does not excced the
    browser window height limit
  */
  adjustTableMaxHeight = () => {
    const browserHeight = UtilsInstance.getBrowserWindowHeight();
    let newTableMaxHeight = browserHeight * 0.7;
    newTableMaxHeight = newTableMaxHeight.toString();
    newTableMaxHeight = newTableMaxHeight.concat("px");
    document.getElementById("main-table-container").style["maxHeight"] = newTableMaxHeight;
  }

  /*
    Saves the form input to the component state everytime the user
    types something in the form
  */
  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  /*
    Remove offline or duplicate device from the live list
  */
  removeOfflineOrDuplicateDevice = (deviceMacAddress) => {
    let data = JSON.stringify({
      mac: deviceMacAddress
    });

    fetch(Constants.REQUEST_IP_ADDRESS + "remove_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: data
    })
      .then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.REMOVE_DEVICE_SUCCESS);
      })
      .catch((error) => {
        alert(Strings.REMOVE_DEVICE_FAILURE + "\n" + Strings.REASON_DP + error);
      });
  }

  handleModalDeleteClick = () => {
    this.setState({
      showModal: false,
      showZeroIpModal: false
    });
    this.removeOfflineOrDuplicateDevice(this.state.clickedMac);
  }

  handleModalLogClick = () => {
    this.setState({ showModal: false }, () => {
      this.props.onChangeLog();
      this.props.history.push({
        pathname: "/log",
        state: { deviceIP: this.state.clickedDevice }
      });
    });
  }

  closeModal = () => this.setState({ showModal: false })

  closeZeroIpModal = () => this.setState({ showZeroIpModal: false })

  getDeviceAvailability = (device) => {
    for (let i = 0; i < this.state.maintenance.length; i++) {
      if (this.state.maintenance[i].mac === device.mac) {

        // The device availability is the percentage of time it was on "OK" status +
        // the percentage of time it was on "Alarme" status
        let availability = this.state.maintenance[i].percentageAvailable
          + this.state.maintenance[i].percentageDiagnostic;

        // Never let the availability be greater than 100%
        if (availability >= 100) {
          availability = 100;
        }

        return availability;
      }
    }
  }

  getPingData = (device) => {
    let pingData = {
      "pingAvg": "",
      "pingCurrent": "",
      "lostPings": "",
      "lostPingsPercentage": ""
    };

    for (let i = 0; i < this.state.ping.length; i++) {
      if (this.state.ping[i].mac === device.mac) {
        pingData = {
          "pingAvg": this.state.ping[i].pingAvg,
          "pingCurrent": this.state.ping[i].pingCurrent,
          "lostPings": this.state.ping[i].lostPings,
          "lostPingsPercentage": this.state.ping[i].lostPingsPercentage
        };
        return pingData;
      }
    }

    // If no device was found, return and empty ping data object
    return pingData;
  }

  getFormatedAvailability = (availability) => {
    if (availability !== null && availability !== undefined && typeof (availability) === "number") {
      return availability.toFixed(2).replace(".", ",").concat("%");
    }
    else {
      return "";
    }
  }

  getNameTextForCSV = (tag) => {
    if (tag === undefined || tag === null) {
      return " ";
    }
    else {
      return tag.replace(/,/g, " ");
    }
  }

  getAvailabilityForCSV = (availability) => {
    if (availability !== null && availability !== undefined && typeof (availability) === "number") {
      return availability.toFixed(2);
    }
    else {
      return "";
    }
  }

  getStatusTextForCSV = (device) => {
    if (device.isInBlacklist && device.isIgnoringMonitoring) {
      return Strings.MONITORING_BLACKLIST_STRING;
    }
    else if (device.isInBlacklist && !device.isIgnoringMonitoring) {
      if (device.status === Constants.OK) {
        return Strings.BLACKLIST_OK_STRING;
      }
      else if (device.status === Constants.DIAGNOSTIC) {
        return Strings.BLACKLIST_ALARM_STRING;
      }
      else if (device.status === Constants.OFFLINE) {
        return Strings.BLACKLIST_OFFLINE_STRING;
      }
      else if (device.status === Constants.ONLINE) {
        return Strings.BLACKLIST_ONLINE_STRING;
      }
      else if (device.status === Constants.FAULT) {
        return Strings.BLACKLIST_FAULT_STRING;
      }
      else if (device.status === Constants.DUPLICATE_IP) {
        return Strings.BLACKLIST_DUPLICATE_IP_STRING;
      }
      else if (device.status === Constants.CONFIG_ERROR) {
        return Strings.BLACKLIST_CONFIG_ERROR_STRING;
      }
    }
    else {
      if (device.status === Constants.OK) {
        return Strings.OK_STRING;
      }
      else if (device.status === Constants.DIAGNOSTIC) {
        return Strings.ALARM;
      }
      else if (device.status === Constants.OFFLINE) {
        return Strings.OFFLINE_STRING;
      }
      else if (device.status === Constants.ONLINE) {
        return Strings.ONLINE_STRING;
      }
      else if (device.status === Constants.FAULT) {
        return Strings.FAULT_STRING;
      }
      else if (device.status === Constants.DUPLICATE_IP) {
        return Strings.DUPLICATE_IP_STRING;
      }
      else if (device.status === Constants.CONFIG_ERROR) {
        return Strings.CONFIG_ERROR_STRING;
      }
    }
  }

  exportLiveListAsCSV = () => {
    let csvText = Strings.LIVE_LIST_CSV_HEADER;

    for (let i = 0; i < this.state.originalDevices.length; i++) {
      let lostPingsPercentage = this.state.originalDevices[i].lostPingsPercentage;
      lostPingsPercentage = (lostPingsPercentage !== "") ? lostPingsPercentage.toFixed(2) : lostPingsPercentage;

      csvText += this.getNameTextForCSV(this.state.originalDevices[i].name) + ","
        + this.state.originalDevices[i].tag + ","  
        + this.state.originalDevices[i].mac + ","
        + this.state.originalDevices[i].ip + ","
        + this.state.originalDevices[i].nAlarm + ","
        + this.state.originalDevices[i].nFault + ","
        + this.state.originalDevices[i].pingCurrent + ","
        + this.state.originalDevices[i].pingAvg + ","
        + this.state.originalDevices[i].lostPings + ","
        + lostPingsPercentage + ","
        + this.getAvailabilityForCSV(this.state.originalDevices[i].availability) + ","
        + this.getStatusTextForCSV(this.state.originalDevices[i]) + "\n";
    }

    const workbook = read(csvText, { type: "string", raw: true });
    /* Aqui convertemos o workbook para o formato .xlsx */
    const wbout = write(workbook, { bookType: "xlsx", type: "binary" });

    /* Criação do blob e link para download */
    const blob = new Blob([UtilsInstance.s2ab(wbout)], { type: "application/octet-stream" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = Strings.LIVE_LIST_CSV_EXPORT_NAME;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    sessionStorage.removeItem("auth");
    this.retrieveData();
    // store intervalId in the state so it can be accessed later
    this.setState({ intervalID: setInterval(this.retrieveData, 5000) });
    this.adjustTableMaxHeight();
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalID);
  }

  componentDidUpdate() {
    this.adjustTableMaxHeight();
  }

  // Render the table containing all network devices
  render() {
    const column = this.state.column;
    const direction = this.state.sortDirection;
    const filter = this.state.formInput;

    const devices = this.state.devices.map(device => (
      <Table.Row key={device.mac}>
        <Table.Cell style={{ display: this.state.activeColumns.name ? "table-cell" : "none" }} verticalAlign="middle">{UtilsInstance.addWhitespaceToLongStrings(device.name, false)}</Table.Cell>
        <Table.Cell style={{ display: this.state.activeColumns.tag ? "table-cell" : "none" }} verticalAlign="middle">{device.tag || "-"}</Table.Cell>
        <Table.Cell style={{ display: this.state.activeColumns.mac ? "table-cell" : "none" }} verticalAlign="middle">{device.mac}</Table.Cell>
        {this.createIpCell(device)}
        <Table.Cell style={{ display: this.state.activeColumns.alarms ? "table-cell" : "none" }} verticalAlign="middle">{device.nAlarm}</Table.Cell>
        <Table.Cell style={{ display: this.state.activeColumns.faults ? "table-cell" : "none" }} verticalAlign="middle">{device.nFault}</Table.Cell>
        <Table.Cell style={{ display: this.state.activeColumns.ping ? "table-cell" : "none" }} verticalAlign="middle">{device.pingAvg} / {device.pingCurrent}</Table.Cell>
        <Table.Cell style={{ display: this.state.activeColumns.lostPackets ? "table-cell" : "none" }} verticalAlign="middle">{device.lostPings} / {device.lostPingsPercentage}%</Table.Cell>
        <Table.Cell style={{ display: this.state.activeColumns.availability ? "table-cell" : "none" }} verticalAlign="middle">{this.getFormatedAvailability(device.availability)}</Table.Cell>
        {this.createStatusCell(device)}
      </Table.Row>
    ));

    return (
      <div style={screenStyle}>

        <div className="livelist-toolbar">
          <div className="livelist-availability-card">
            <span className="livelist-availability-label">{Strings.NETWORK_AVAILABILITY_DP.replace(":", "")}</span>
            <span className="livelist-availability-value">{this.state.networkAvailability || "-"}</span>
          </div>
          <Form className="livelist-search-form" onSubmit={this.handleSubmit}>
            <Form.Input id="inputform" className="livelist-search-input" placeholder={Strings.LIVE_LIST_INPUT_TEXT_PLACEHOLDER} icon="search" name="formInput" value={filter} onChange={this.handleChange} />
          </Form>
          <div className="livelist-toolbar-actions">
            <div className="livelist-columns-dropdown"><ColumnsDropdown onChange={(activeColumns) => this.setState({ activeColumns })} /></div>
            <Button content={Strings.EXPORT_CSV} color="teal" onClick={this.exportLiveListAsCSV} />
          </div>
        </div>

        <Table id="table-header" style={headerMarginStyle} sortable fixed selectable textAlign="center">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell
                style={{ display: this.state.activeColumns.name ? "table-cell" : "none" }}
                sorted={column === "name" ? direction : null}
                onClick={this.handleSort("name")}>
                {Strings.NAME}
              </Table.HeaderCell>

              <Table.HeaderCell
                style={{ display: this.state.activeColumns.tag ? "table-cell" : "none" }}
                sorted={column === "tag" ? direction : null}
                onClick={this.handleSort("tag")}>
                {Strings.TAG}
              </Table.HeaderCell>

              <Table.HeaderCell
                style={{ display: this.state.activeColumns.mac ? "table-cell" : "none" }}
                disabled>
                {Strings.MAC}
              </Table.HeaderCell>

              <Popup position='bottom left' hoverable pinned
                trigger={
                  <Table.HeaderCell
                    style={{ display: this.state.activeColumns.ip ? "table-cell" : "none" }}
                    sorted={column === "ip" ? direction : null}
                    onClick={this.handleSort("ip")}>
                    {Strings.IP}
                    <Icon name="question circle" color="teal" style={questionIconStyle} />
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p style={{ marginTop: "1vh" }}>{Strings.IP_POPUP_2}</p>
                  <div style={zeroIpPopupExampleStyle}>
                    <span style={zeroIpBadgeStyle}>0.0.0.0</span>
                  </div>
                  <p style={{ marginTop: "1vh" }}>{Strings.IP_POPUP_3}</p>
                </Popup.Content>
              </Popup>

              <Popup position='bottom center' hoverable pinned
                trigger={
                  <Table.HeaderCell
                    style={{ display: this.state.activeColumns.alarms ? "table-cell" : "none" }}
                    sorted={column === "nAlarm" ? direction : null}
                    onClick={this.handleSort("nAlarm")}>
                    {Strings.ALARMS}
                    <Icon name="question circle" color="teal" style={questionIconStyle} />
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  {Strings.ALARMS_QUESTION_INFO}
                </Popup.Content>
              </Popup>

              <Popup position='bottom center' hoverable pinned
                trigger={
                  <Table.HeaderCell
                    style={{ display: this.state.activeColumns.faults ? "table-cell" : "none" }}
                    sorted={column === "nFault" ? direction : null}
                    onClick={this.handleSort("nFault")}>
                    {Strings.FAULTS}
                    <Icon name="question circle" color="teal" style={questionIconStyle} />
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  {Strings.FAULTS_QUESTION_INFO}
                </Popup.Content>
              </Popup>

              <Table.HeaderCell style={{ display: this.state.activeColumns.ping ? "table-cell" : "none" }} disabled>
                {Strings.PING} <br />
                {Strings.ACTUAL_MEDIUM} (ms)
              </Table.HeaderCell>

              <Popup position='bottom center' hoverable pinned wide
                trigger={
                  <Table.HeaderCell
                    style={{ display: this.state.activeColumns.lostPackets ? "table-cell" : "none" }}
                    sorted={column === "lostPingsPercentage" ? direction : null}
                    onClick={this.handleSort("lostPingsPercentage")}>
                    {Strings.LOST_PACKET_PERC_1}
                    <Icon name="question circle" color="teal" style={questionIconStyle} /> <br />
                    {Strings.LOST_PACKET_PERC_2}
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.MISSED_PINGS_POPUP}</p>
                </Popup.Content>
              </Popup>

              <Popup position='bottom center' hoverable pinned wide
                trigger={
                  <Table.HeaderCell
                    style={{ display: this.state.activeColumns.availability ? "table-cell" : "none" }}
                    sorted={column === "availability" ? direction : null}
                    onClick={this.handleSort("availability")}>
                    {Strings.AVAILABILITY}<Icon name="question circle" color="teal" style={questionIconStyle} />
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.AVAILABILITY_QUESTION_INFO_1}</p>
                  <p>{Strings.AVAILABILITY_QUESTION_INFO_2}</p>
                </Popup.Content>
              </Popup>

              <Popup position='bottom right' hoverable pinned wide="very"
                trigger={
                  <Table.HeaderCell
                    style={{ display: this.state.activeColumns.status ? "table-cell" : "none" }}
                    sorted={column === "status" ? direction : null}
                    onClick={this.handleSort("status")}>
                    {Strings.STATUS}<Icon name="question circle" color="teal" style={questionIconStyle} />
                  </Table.HeaderCell>
                }>
                <Popup.Content style={{ width: "1000px" }}>
                  <Grid columns={2}>
                    <Grid.Row style={{ marginLeft: "20px", marginRight: "20px" }}>
                      <Grid.Column>
                        <div style={popupContainerStyle}>
                          <span style={{ ...statusBadgeStyles.ok, ...popupStatusBadgeStyle }}>{Strings.OK_STRING}</span>
                          <p>{Strings.LIVE_LIST_OK_POPUP_TEXT}</p>
                        </div>
                        <Divider style={popupDividerStyle} />
                        <div style={popupContainerStyle}>
                          <span style={{ ...statusBadgeStyles.diagnostic, ...popupStatusBadgeStyle }}>{Strings.ALARM}</span>
                          <p>{Strings.LIVE_LIST_DIAGNOSTIC_POPUP_TEXT}</p>
                        </div>
                        <Divider style={popupDividerStyle} />
                        <div style={popupContainerStyle}>
                          <span style={{ ...statusBadgeStyles.fault, ...popupStatusBadgeStyle }}>{Strings.FAULT_STRING}</span>
                          <p>
                            {Strings.LIVE_LIST_FAULT_POPUP_TEXT}
                            <br />
                            <b>{Strings.PS}</b> {Strings.LIVE_LIST_DUPLICATE_IP_POPUP_TEXT_2}
                          </p>
                        </div>
                        <Divider style={popupDividerStyle} />
                        <div style={popupContainerStyle}>
                          <span style={{ ...statusBadgeStyles.online, ...popupStatusBadgeStyle }}>{Strings.ONLINE_STRING}</span>
                          <p>{Strings.LIVE_LIST_ONLINE_POPUP_TEXT}</p>
                        </div>
                      </Grid.Column>
                      <Grid.Column>
                        <div style={popupContainerStyle}>
                          <span style={{ ...statusBadgeStyles.offline, ...popupStatusBadgeStyle }}>{Strings.OFFLINE_STRING}</span>
                          <p>{Strings.LIVE_LIST_OFFLINE_POPUP_TEXT}</p>
                        </div>
                        <Divider style={popupDividerStyle} />
                        <div style={popupContainerStyle}>
                          <span style={{ ...statusBadgeStyles.duplicated, ...popupStatusBadgeStyle }}>{Strings.DUPLICATE_IP_STRING}</span>
                          <p>
                            {Strings.LIVE_LIST_DUPLICATE_IP_POPUP_TEXT}
                            <br />
                            <b>{Strings.PS}</b> {Strings.LIVE_LIST_DUPLICATE_IP_POPUP_TEXT_2}
                          </p>
                        </div>
                        <Divider style={popupDividerStyle} />
                        <div style={popupContainerStyle}>
                          <span style={{ ...statusBadgeStyles.blacklist, ...popupStatusBadgeStyle }}>{Strings.MONITORING_BLACKLIST_STRING}</span>
                          <p>{Strings.LIVE_LIST_BLACKLIST_POPUP_TEXT}</p>
                        </div>
                        <Divider style={popupDividerStyle} />
                        <div style={popupContainerStyle}>
                          <span style={{ ...statusBadgeStyles.configError, ...popupStatusBadgeStyle }}>{Strings.CONFIG_ERROR_STRING}</span>
                          <p style={popupStatusTextStyle}>{Strings.LIVE_LIST_CONFIG_ERROR_POPUP_TEXT}</p>
                        </div>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>

                </Popup.Content>
              </Popup>

            </Table.Row>
          </Table.Header>
        </Table>

        <div id="main-table-container" className="livelist-table-container" style={tableStyle}>
          <Table id="main-table" sortable fixed selectable textAlign="center">
            <Table.Body>{devices}</Table.Body>
          </Table>

          <Modal centered open={this.state.showModal} onClose={this.closeModal} basic size='small'>
            <Header icon='trash' content={Strings.GO_TO_LOG_OR_REMOVE_POSITIONING} />
            <Modal.Content>
              <p> {Strings.ASK_DELETE_OR_LOG} </p>
            </Modal.Content>
            <Modal.Actions>
              <Button color='red' inverted onClick={this.handleModalDeleteClick}><Icon name='remove' />{Strings.DELETE}</Button>
              <Button color='green' inverted onClick={this.handleModalLogClick}><Icon name='checkmark' />{Strings.GO_TO_LOG}</Button>
            </Modal.Actions>
          </Modal>

          <Modal centered open={this.state.showZeroIpModal} onClose={this.closeZeroIpModal} basic size='small'>
            <Header icon='trash' content={Strings.REMOVE_LOST_IP_MODAL_HEADER} />
            <Modal.Content>
              <p>{Strings.REMOVE_LOST_IP_MODAL_CONTENT_1}</p>
              <p><b>{Strings.PS}</b> {Strings.REMOVE_LOST_IP_MODAL_CONTENT_2}</p>
            </Modal.Content>
            <Modal.Actions>
              <Button color='red' inverted onClick={this.closeZeroIpModal}><Icon name='remove' />{Strings.NO}</Button>
              <Button color='green' inverted onClick={this.handleModalDeleteClick}><Icon name='checkmark' />{Strings.YES}</Button>
            </Modal.Actions>
          </Modal>

        </div>

      </div>
    );
  }
}

// CSS custom table stylization
const screenStyle = {
  marginTop: "8px",
  marginLeft: "4px",
  marginRight: "4px",
  marginBottom: "8px",
};

const tableStyle = {
  overflowY: "auto",
  overflowX: "auto",
  marginTop: "8px",
  maxWidth: "100%"
};

const headerMarginStyle = {
  marginTop: "0px",
  marginBottom: "8px",
  width: "99.5%"
};

const statusCellStyle = {
  verticalAlign: "middle",
  backgroundColor: "transparent"
};

const statusBadgeBaseStyle = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: "130px",
  minWidth: "130px",
  height: "44px",
  padding: "5px 10px",
  borderRadius: "999px",
  fontSize: "12px",
  fontWeight: 700,
  lineHeight: "16px",
  textAlign: "center",
  whiteSpace: "normal",
  wordBreak: "break-word",
  border: "1px solid transparent"
};

const statusBadgeStyles = {
  ok: { ...statusBadgeBaseStyle, color: "black", background: "lime", borderColor: "lime" },
  diagnostic: { ...statusBadgeBaseStyle, color: "black", background: "yellow", borderColor: "yellow" },
  offline: { ...statusBadgeBaseStyle, color: "black", background: "lightGrey", borderColor: "lightGrey" },
  online: { ...statusBadgeBaseStyle, color: "black", background: "lightBlue", borderColor: "lightBlue" },
  fault: { ...statusBadgeBaseStyle, color: "black", background: "red", borderColor: "red" },
  duplicated: { ...statusBadgeBaseStyle, color: "white", background: "purple", borderColor: "purple" },
  blacklist: { ...statusBadgeBaseStyle, color: "white", background: "black", borderColor: "black" },
  configError: { ...statusBadgeBaseStyle, color: "black", background: "LightPink", borderColor: "LightPink" },
  default: { ...statusBadgeBaseStyle, color: "#4d5358", background: "rgba(182, 188, 193, 0.42)", borderColor: "rgba(125, 133, 140, 0.56)" }
};

const zeroIpCellStyle = {
  backgroundColor: "transparent",
  cursor: "pointer"
};

const zeroIpPopupExampleStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  margin: "12px 0 14px"
};

const zeroIpBadgeStyle = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: "82px",
  padding: "5px 10px",
  borderRadius: "999px",
  color: "black",
  backgroundColor: "orange",
  border: "1px solid orange",
  fontSize: "12px",
  fontWeight: 700,
  lineHeight: "16px"
};

const popupStatusBadgeStyle = {
  flex: "0 0 130px",
  marginRight: "12px"
};

const mapActionsToProps = {
  onChangeLog: logAction
};

const questionIconStyle = {
  marginLeft: "4px"
};

const popupContainerStyle = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center"
};


const popupStatusTextStyle = {
  textAlign: "left"
};

const popupDividerStyle = {
  marginTop: "4px",
  marginBottom: "4px",
  color: "rgba(64, 64, 64, 0.5)"
};

export default connect(null, mapActionsToProps)(withRouter(LiveList));